module.exports = __webpack_public_path__ + "static/02_juliana ballard-950da09bc8705649e01ae37fb31c0218.jpg";